import React, { useMemo } from 'react';

// DEPENDENCIES
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';

// LOCAL COMPONENTS
import ListCell from './ListCell';
import LinkCell from './LinkCell';

// FUNCTIONS
const assignmentItem = (row, key, value) => ({
  value: value || row[key],
  className: row[`${key}_has_changed`] ? 'text-danger' : undefined
})

// MAIN COMPONENT
const AssignmentCell = ({
  children,
  value = children,
  placeholder,
  ...props
}) => {

  // PROPS
  const {
    column: {
      id,
      key2,
      to
    },
    row: {
      original
    }
  } = props

  // MEMOS
  const valueMemo = useMemo(
    () => {
      if (!value) return null;
      if (isArray(value) && !isEmpty(value)) return value;
      const output = [];
      output.push(assignmentItem(original, id, value));
      if (key2 && original[key2]) output.push(assignmentItem(original, key2));
      return output;
    },
    [value, id, key2, original]
  )
  const childrenMemo = useMemo(
    () => isArray(valueMemo) ? <ListCell>{valueMemo}</ListCell> : valueMemo,
    [valueMemo]
  )

  // RENDER
  return !childrenMemo ? placeholder : to ? <LinkCell {...props}>{childrenMemo}</LinkCell> : childrenMemo;
};

// EXPORT
export default AssignmentCell;
